* HTML document, ASCII text, with CRLF line terminators
<template>
	<div>
		<loading v-bind:dspin="!loaded"></loading>
		<div v-if="loaded" v-bind:class="cls1">
			<!-- CONTENT START -->
			<div class="dispatch w3-table">
				<div v-for="each in statuses" :id="each.status" class="status"
						 v-on:drop="onDrop(each.status,$event)"
						 v-on:dragover='onDragOver($event)'>
					<!--{{each.status}}-->
					<!--Show status column-->
					<statusColumn :status="each" :appointments="statusAppointments[each.status]"
												:statuses="statuses"
												:plugin="plugin"
												:checkNotifications="checkNotifications"
					></statusColumn>
				</div>
			</div>

			<!--RIGHT CONTENT STARTS HERE = PATIENT INFO + NEW PATIENT -->
			<div v-if="openPatientCard"
					 class="w3-col content-sidebar-right top-from-header w3-animate-right flow-padding-top">
				<patient-side-card class="flow-padding-top"
													 :selectedPatient="selectedPatient"
													 :selectedPatientStatus="selectedPatient.status"
													 :selectedPatientDevice="selectedPatient.device"
													 :onClose="() => {openPatientCard = false; this.activePatientId = undefined}">
				</patient-side-card>
			</div>
			<!-- CONTENT END -->
		</div>
	</div>
</template>

<style>
.dispatch {
	display: inline-flex;
}

.dispatch .status {
	border-right: 1px solid #ddd;
	padding: 0 10px;
	width: 20%;
	height: auto;
	overflow: hidden;
	min-height: 80vh;
}

.dispatch .status:last-of-type {
	border-right: none;
}

.dispatch .status.folded {
	width: 5%;
	overflow: visible;
	text-transform: uppercase;
	letter-spacing: 10px;
}

.dispatch .status.folded h1 {
	-webkit-transform: rotate(90deg);
	-moz-transform: rotate(90deg);
	-o-transform: rotate(90deg);
	transform: rotate(90deg);
}

.dispatch .status h1 i {
	padding-top: 5px;
}
</style>

<script>
import Vue from 'vue';
import {EventBus} from "@/main";
import ContentHeader from "@/components/common/ContentHeader";
import Loading from "@/components/common/Loading";
import StatusColumn from "@/components/status-overview/dh/dhStatusColumn.vue";
import PatientSideCard from "@/components/patient/PatientSideCard";

const frc = Vue.prototype.$frc;

export default {
	name: "dhDispatch",
	components: {ContentHeader, Loading, StatusColumn, PatientSideCard},
	props: ['ftitle'],
	data: function () {
		return {
			loaded: false,
			openPatientCard: false,
			selectedPatient: {},
			activePatientId: undefined,
			allAppointments: [],
			statusAppointments: {},
			refreshIntervalId: undefined,
			statuses: [{
				"rank": 0,
				"status": "SUBSCRIPTIONS"
			}],
			draggedAppointment: undefined,
			serverTime: undefined,
			refreshServerTime: undefined,
			plugin: ''

		}
	},
	beforeDestroy() {
		EventBus.$off("dhPatientSelected", this.openPatientDetail);
		EventBus.$off("dragStarted", this.startDrag);
		EventBus.$off("forwardPushed", this.forwardPatient);
		EventBus.$off("patientUpdated", this.updateStatus);
		clearInterval(this.refreshIntervalId);
		clearInterval(this.refreshServerTime);
	},
	mounted() {
		EventBus.$on("dhPatientSelected", this.openPatientDetail);
		EventBus.$on("dragStarted", this.startDrag);
		EventBus.$on("forwardPushed", this.forwardPatient);
		EventBus.$on("patientUpdated", this.updateStatus);
		this.refreshIntervalId = setInterval(this.refreshPatients, 5000);
		this.refreshServerTime = setInterval(this.getServerTime, 40000);
		this.getServerTime();
		this.getStatuses();
	},
	created() {
		console.log(Vue.prototype.$currentWard.uisettings.plugin);
		this.plugin = Vue.prototype.$currentWard.uisettings.plugin;
	},
	computed: {
		isCardOpen() {
			return this.openPatientCard;
		},
		cls0() {
			if (!this.isCardOpen) return 'flow-margin-right';

			return 'content-sidebar-header ' + (this.openPatientAlerts ? 'sidebars-70-30' : 'sidebars-50-50');
		},
		cls1() {
			if (!this.isCardOpen) return '';

			return 'content-sidebars ' + (this.openPatientAlerts ? 'sidebars-70-30' : 'sidebars-50-50');
		}

	},
	methods: {
		getServerTime() {
			let app = this;
			frc.getServerTime().then(function (res) {
				app.serverTime = res.data;
			}).catch(function (ex) {
				console.log(ex);
			})
		},
		getWA() {
			let app = this;
			let wardId = Vue.prototype.$currentWard.id;
			let WAs = [];
			frc.getConsultationGroupsInWard(wardId).then(function (res) {
				let groups = res.data;
				for (let i = 0; i < groups.length; i++) {
					frc.getWaitingAreasInConsultationGroup(wardId, groups[i].id).then(function (res) {
						let areas = res.data;
						for (let i = 0; i < areas.length; i++) {
							WAs.push(areas[i]);
						}
					}).catch(function (ex) {
						console.log(ex)
					})
				}
				app.statuses.push({
					"rank": 1,
					"status": "WAITING",
					"positions": WAs
				});
				Vue.sortByKeyInt(app.statuses, 'rank');
			}).catch(function (ex) {
				console.log(ex)
			})
		},
		refreshPatients() {
			this.getAppointments();
		},
		openPatientDetail(patient) {
			this.openPatientCard = true;
			this.selectedPatient = patient;
			this.activePatientId = patient.id;

		},
		getStatuses: function () {
			let app = this;
			app.getWA();
			frc.getFromPlugin(this.plugin, 'statuses').then(function (res) {
				let incomingStatuses = res.data;
				for (let i = 0; i < incomingStatuses.length; i++) {
					app.statuses.push(incomingStatuses[i]);
				}
				Vue.sortByKeyInt(app.statuses, 'rank');
				app.getAppointments();
			}).catch(function (ex) {
				console.log(ex);
				app.loaded = false;
			})
		},
		getAppointments: function () {
			const wardId = Vue.prototype.$currentWard.id;
			let app = this;
			let keyValueMap = {};
			frc.getPatientsForWard(wardId).then(function (res) {
				for (let i = 0; i < app.statuses.length; i++) {
					app.allAppointments = res.data;
					let st = app.statuses[i];
					let ap = app.getAppointmentsForStatus(st, res.data);
					keyValueMap[st.status] = ap;
				}
				app.statusAppointments = keyValueMap;
				app.loaded = true;
				app.checkNotifications();

			}).catch(function () {
				app.loaded = false;
			});
		},
		checkNotifications() {
			let items = localStorage.getItem("notifyAppointments" + this.plugin);
			let lsitems = {};
			let statuses = this.statuses;
			let notify = false;
			if (items) {
				lsitems = JSON.parse(items);
				for (let i = 0; i < statuses.length; i++) {
					let appointments = lsitems[statuses[i].status];
					if (appointments.length > 0) {
						notify = true;
						break;
					}
				}

				EventBus.$emit("checkNotifications", notify);
			}
		},
		getAppointmentsForStatus: function (status, allAppointments) {
			let appointments = [];
			let appointmentStatus = null;
			let maxTimeAllowed = status.maxTimeAllowedInMilli;
			let statusChangedAt = 0;
			let timeSpent = undefined;
			for (let i = 0; i < allAppointments.length; i++) {
				if (allAppointments[i].patientStatus === 'Active') {
					let currentAppointment = allAppointments[i];
					// statusChangedAt = Vue.getValueForKey(currentAppointment.appointmentTypeProperties.entry, 'statusChangedAt');
					statusChangedAt = currentAppointment.appointmentTypeStatusChangedAt;
					timeSpent = this.serverTime - statusChangedAt;
					currentAppointment.timeSpent = timeSpent;
					appointmentStatus = Vue.getAppointmentStatus(currentAppointment);
					if (status.status === appointmentStatus || appointmentStatus === "OUT_OF_" + status.status) {
						currentAppointment.overstay = (maxTimeAllowed === undefined || maxTimeAllowed < 0) ? false : (timeSpent > maxTimeAllowed);
						currentAppointment.currentStatus = status.status;
						appointments.push(currentAppointment);
					}
				}
			}
			return appointments;
		},

		startDrag(appointment) {
			this.draggedAppointment = appointment;

		},
		onDragOver: function (event) {
			event.preventDefault();
		},
		onDrop(targetStatus, event) {
			let app = this;
			let patient = app.draggedAppointment;
			app.disableForward(patient);
			let draggedAppStatus = patient ? patient.currentStatus : null;
			let targetStatusPermitted = false;
			frc.getPermittedPositions(patient.ticket, patient.appointmentId).then(function (res) {
				let permittedStatusPositions = {};
				let permittedPositions = res.data;
				permittedPositions.forEach((position) => {
					let status = Vue.getStatusFromPosition(position.id, app.statuses);
					position.status = status.status;
					position.statusRank = status.rank;
					permittedStatusPositions[status.status] = position.id;
					if (targetStatus === status.status) {
						targetStatusPermitted = true;
					}
				})
				Vue.sortByKeyInt(permittedPositions, 'statusRank');
				if (draggedAppStatus) {
					if (draggedAppStatus === targetStatus) {
						console.log("Same status");
						app.enableForward(patient);
					} else {
						if (targetStatusPermitted === true) {
							app.movePatient(patient, permittedStatusPositions[targetStatus], targetStatus);
						} else {
							Vue.notifyError({message: app.$t("cantMovePatient", {'status': app.$t(targetStatus)})});
							app.enableForward(patient);
						}
					}
				}
			}).catch(function (ex) {
				console.log(ex);
			});

			event.dataTransfer.clearData();

		},
		forwardPatient: function (patient) {
			let app = this;
			app.disableForward(patient);
			frc.getPermittedPositions(patient.ticket, patient.appointmentId).then(function (res) {
				let permittedPositions = res.data;
				permittedPositions.forEach((position) => {
					let status = Vue.getStatusFromPosition(position.id, app.statuses);
					position.status = status.status;
					position.statusRank = status.rank;
				})
				Vue.sortByKeyInt(permittedPositions, 'statusRank');
				if (permittedPositions.length === 0) {
					console.log("No permitted positions");
					Vue.notifyError({message: app.$t("cantMovePatient")});
					app.enableForward(patient);
				} else {
					app.movePatient(patient, permittedPositions[0].id, permittedPositions[0].status);
				}
			}).catch(function (ex) {
				console.log(ex);
				Vue.notifyError({message: app.$t("cantMovePatient")});
				app.enableForward(patient);
			})
		},
		movePatient: function (patient, posid, toStatus) {
			let app = this;
			let aid = patient.appointmentId;
			frc.movePatientNC(patient.patientId, aid, posid).then(function (res) {
				Vue.prototype.$forwardedAppointmentDH = {"patient": patient, "toStatus": toStatus};
				app.getAppointments();
				app.enableForward(patient);
			}).catch(function (ex) {
				console.log(ex);
				app.enableForward(patient);
			})
		},
		enableForward(patient) {
			// document.getElementById(patient.appointmentId).style.display = 'block';
			if (document.getElementById(patient.appointmentId + "_forward")) {
				document.getElementById(patient.appointmentId + "_forward").classList.remove('w3-hide');
			}
			document.getElementById(patient.appointmentId).classList.remove('w3-disabled');
			document.getElementById(patient.appointmentId).draggable = true;
		},
		disableForward(patient) {
			// document.getElementById(patient.appointmentId).style.display = 'none';
			if (document.getElementById(patient.appointmentId + "_forward")) {
				document.getElementById(patient.appointmentId + "_forward").classList.add('w3-hide');
			}
			document.getElementById(patient.appointmentId).classList.add('w3-disabled');
			document.getElementById(patient.appointmentId).draggable = false;
		},
		updateStatus(patientId) {
			let app = this;
			frc.getPatientInWard(Vue.prototype.$currentWard.id, patientId).then(function (res) {
				if (!res.data) {
					console.log("Patient not found.");
					return;
				}
				app.selectedPatient.status = res.data.status;
			});
		}
	}
}
</script>